import { InputLabel, MenuItem, Select, OutlinedInput, Skeleton } from "@mui/material"
import { Fragment } from "react"
import { uid } from "uid"

function SelectInput({ id, label, options = [], renderValueKey, selectLabel, varianttype, loading = false, disabledInitial = true, ...rest }) {
  id = id || uid(6)

  return (
    <Fragment>
      {label &&
        <InputLabel htmlFor={id}>{label}</InputLabel>
      }
      {loading ?
        <Skeleton
          sx={{
            width: "100%",
            height: "100%",
            transform: "none",
            maxHeight: "40px",
          }}
        /> :
        <Select
          fullWidth
          size="small"
          defaultValue={"[object Object]"}
          input={<OutlinedInput id={id} />}
          renderValue={(option) => option[renderValueKey] || selectLabel || "Select"}
          {...rest}
        >
          <MenuItem
            disabled={disabledInitial}
            value="[object Object]"
            sx={{
              fontSize: "14px",
              fontFamily: "Poppins"
            }}
          >{selectLabel || "Select"}
          </MenuItem>
          {options?.map((option, i) => (
            <MenuItem
              sx={{
                color: "black",
                fontSize: "14px",
                fontFamily: "Poppins",
                textTransform: "capitalize"
              }}
              key={i}
              value={option}
              disableRipple
            >{option?.text || option?.name}
            </MenuItem>
          ))}
        </Select>
      }
    </Fragment>
  )
}

export default SelectInput